/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as XyzenablementRouteImport } from './routes/xyzenablement'
import { Route as EnablementRouteImport } from './routes/enablement'
import { Route as DemandRouteImport } from './routes/demand'
import { Route as IndexRouteImport } from './routes/index'

const XyzenablementRoute = XyzenablementRouteImport.update({
  id: '/xyzenablement',
  path: '/xyzenablement',
  getParentRoute: () => rootRouteImport,
} as any)
const EnablementRoute = EnablementRouteImport.update({
  id: '/enablement',
  path: '/enablement',
  getParentRoute: () => rootRouteImport,
} as any)
const DemandRoute = DemandRouteImport.update({
  id: '/demand',
  path: '/demand',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/demand': typeof DemandRoute
  '/enablement': typeof EnablementRoute
  '/xyzenablement': typeof XyzenablementRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/demand': typeof DemandRoute
  '/enablement': typeof EnablementRoute
  '/xyzenablement': typeof XyzenablementRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/demand': typeof DemandRoute
  '/enablement': typeof EnablementRoute
  '/xyzenablement': typeof XyzenablementRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/demand' | '/enablement' | '/xyzenablement'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/demand' | '/enablement' | '/xyzenablement'
  id: '__root__' | '/' | '/demand' | '/enablement' | '/xyzenablement'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DemandRoute: typeof DemandRoute
  EnablementRoute: typeof EnablementRoute
  XyzenablementRoute: typeof XyzenablementRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/xyzenablement': {
      id: '/xyzenablement'
      path: '/xyzenablement'
      fullPath: '/xyzenablement'
      preLoaderRoute: typeof XyzenablementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enablement': {
      id: '/enablement'
      path: '/enablement'
      fullPath: '/enablement'
      preLoaderRoute: typeof EnablementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demand': {
      id: '/demand'
      path: '/demand'
      fullPath: '/demand'
      preLoaderRoute: typeof DemandRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DemandRoute: DemandRoute,
  EnablementRoute: EnablementRoute,
  XyzenablementRoute: XyzenablementRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
